// extracted by mini-css-extract-plugin
var _1 = "JZQ2H__messageList";
export { _1 as "messageList" }
